/**
 * Reusable Status Badge Component
 * Displays status with consistent styling
 */
import React from 'react';
import { getStatusBadgeStyle } from '../../utils/statusFilters';

const StatusBadge = ({ status, className = '' }) => {
  if (!status) return null;
  
  const style = getStatusBadgeStyle(status);
  
  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${style.bg} ${style.text} ${className}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
